import { NavItem, Feature } from '@/types'

// Navigation configuration
export const NAV_ITEMS: NavItem[] = [
  {
    title: 'Features',
    href: '#features',
  },
  {
    title: 'About',
    href: '#about',
  },
  {
    title: 'Contact',
    href: '#contact',
  },
]

// Application features
export const FEATURES: Feature[] = [
  {
    title: 'Multi-API Integration',
    description: 'Connect to multiple freight APIs and consolidate data in one unified dashboard.',
    icon: 'Globe',
  },
  {
    title: 'Real-time Updates',
    description: 'Get instant notifications and updates on freight availability and status changes.',
    icon: 'Zap',
  },
  {
    title: 'Enterprise Security',
    description: 'Bank-level security with role-based access control and data encryption.',
    icon: 'Shield',
  },
  {
    title: 'Advanced Filtering',
    description: 'Filter freight by location, equipment type, weight, and custom parameters.',
    icon: 'Filter',
  },
  {
    title: 'Automated Workflows',
    description: 'Set up automated notifications and responses for specific freight criteria.',
    icon: 'Workflow',
  },
  {
    title: 'Analytics Dashboard',
    description: 'Comprehensive analytics and reporting on your freight operations.',
    icon: 'BarChart3',
  },
]

// Company information
export const COMPANY = {
  name: 'AIBoard',
  description: 'The ultimate freight aggregation platform for logistics professionals',
  email: 'support@freightmaster.ai',
  phone: '+1 (224) 634-4556',
  address: '123 Logistics Ave, Freight City, FC 12345',
}

// API endpoints (for future use)
export const API_ENDPOINTS = {
  base: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/api',
  auth: '/auth',
  loads: '/loads',
  integrations: '/integrations',
  users: '/users',
}

// Application configuration
export const APP_CONFIG = {
  name: 'AIBoard',
  version: '1.0.0',
  supportedFormats: ['JSON', 'XML', 'CSV'],
  maxApiConnections: 50,
  refreshInterval: 30000, // 30 seconds
} 